import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const highlightStrongClasses = {
    default: '[&_strong]:bg-dep-default',
    extraMuted: '[&_strong]:bg-dep-extra-muted',
    muted: '[&_strong]:bg-dep-muted',
    secondary: '[&_strong]:bg-dep-secondary',
    tertiary: '[&_strong]:bg-dep-tertiary',
    yellow: '[&_strong]:bg-dep-yellow',
    pinkLight: '[&_strong]:bg-dep-pink-light',
    pink: '[&_strong]:bg-dep-pink',
    purple: '[&_strong]:bg-dep-purple',
    blue: '[&_strong]:bg-dep-blue',
    green: '[&_strong]:bg-dep-green',
    darkGrey: '[&_strong]:bg-dep-dark-grey',
    grey: '[&_strong]:bg-dep-grey',
};
const iconHeightClasses = {
    60: 'h-15',
    187: 'h-46.75',
};
const iconWidthClasses = {
    112: 'w-28',
    144: 'w-36',
};
export const TitleWithIconGrid = React.forwardRef(({ title, items, highlightColor, iconHeight = 60, iconWidth = 112, dataTestId, children }, ref) => {
    const isTwoCol = items.length <= 4;
    return (_jsxs("section", { ref: ref, className: cn('mx-auto grid w-full max-w-360 grid-cols-1 items-center gap-6 px-6 py-10 sm:grid-cols-2 md:grid-cols-[0.9fr_1fr] md:gap-10 md:px-10 md:py-20 xl:gap-x-25 xl:gap-y-15 xl:px-25 [&_strong]:font-normal', highlightColor && highlightStrongClasses[highlightColor]), "data-testid": dataTestId, children: [_jsxs("div", { className: "xs:justify-items-start xs:gap-8 grid content-center justify-items-stretch gap-5", children: [title, children] }), items.length > 0 && (_jsx("div", { className: cn('xs:grid-cols-4 xs:gap-2 grid grid-cols-2 justify-between sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4', isTwoCol && 'md:max-lg:grid-cols-2 md:max-lg:justify-evenly'), children: items.map((item, i) => {
                    const wrapperClassName = cn('grid justify-items-center gap-2 [&:nth-child(n+9)]:max-md:hidden', iconHeight === 60 ? 'p-4' : 'p-0');
                    const content = (_jsxs(_Fragment, { children: [_jsx("div", { className: cn(iconHeightClasses[iconHeight], iconWidthClasses[iconWidth], '*:h-full *:w-full *:object-contain'), children: item.icon }), item.stars] }));
                    return (_jsx(React.Fragment, { children: item.render ? (item.render({
                            className: wrapperClassName,
                            children: content,
                            tabIndex: 0,
                            ...(item.onClick && { onClick: item.onClick }),
                        })) : item.onClick ? (_jsx("button", { type: "button", className: cn(wrapperClassName, 'border-0 bg-transparent text-left'), onClick: item.onClick, children: content })) : (_jsx("div", { className: wrapperClassName, children: content })) }, `grid-icon-${i}`));
                }) }))] }));
});
TitleWithIconGrid.displayName = 'TitleWithIconGrid';
